import { render } from "./Administration.vue?vue&type=template&id=689eab91&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"

import "./Administration.vue?vue&type=style&index=0&id=689eab91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689eab91"]])

export default __exports__